// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"174":"fe726daa","634":"13d7f66b"}[chunkId] + ".chunk.css";
};